import {
  Card,
  CardHeader,
  CardFooter,
  DropdownMenu,
  DropdownItem,
  UncontrolledDropdown,
  DropdownToggle,
  Table,
  Container,
  Row,
  Button,
} from "reactstrap";
import Header from "components/Headers/Header.js";
import { useNavigate } from "react-router-dom";
import { useCallback, useEffect, useState } from "react";
import moment from "moment";
import { errorToast } from "components/toast";
import { successToast } from "components/toast";
import { FormControlLabel, Switch } from "@mui/material";
import Pagination from "components/Pagination";
import { getFaqDataList } from "services/_faq";
import { updateFaqStatus } from "services/_faq";
import { deleteFaqDataById } from "services/_faq";
import { getPermissions } from "context/AuthContext";
const Faq = () => {
  const permissions = getPermissions();
  const navigate = useNavigate();
  const [faqData, setFaqData] = useState([]);
  const [records, setRecords] = useState([]);
  const [page, setPage] = useState(1);
  const [perPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [totalRecords, setTotalRecords] = useState(0);
  const createFaq = () => {
    navigate("create-faq");
  };

  const initialData = useCallback(async () => {
    let payload = `page=${page}&per_page=${perPage}`;
    const data = await getFaqDataList(payload);
    if (data.data) {
      setRecords(data.data.records || []);
      setFaqData(data.data.records);
      setTotalRecords(data.data.total_records || 0);

      if (data.data.total_records && perPage) {
        setTotalPages(Math.ceil(data.data.total_records / perPage));
      }
    }
  }, [page, perPage]);

  useEffect(() => {
    initialData();
  }, [initialData]);

  const handleEdit = async (id) => {
    navigate(`edit-faq/${id}`);
  };

  const handleDelete = async (id) => {
    const data = await deleteFaqDataById({ id });
    if (data.data) {
      successToast(data.message);
      initialData();
    } else {
      errorToast(data.message);
    }
  };

  const handleStatusChange = async (id, newStatus) => {
    try {
      // Call your API to update the status
      const payload = { id, status: newStatus };
      const response = await updateFaqStatus(payload);

      if (response.data) {
        successToast(response.message);

        setFaqData((prev) =>
          prev.map((item) =>
            item.id === id ? { ...item, status: newStatus } : item
          )
        );
      } else {
        errorToast(response.message);
      }
    } catch (err) {
      console.error(err);
      errorToast("Something went wrong!");
    }
  };

  const prevButton = async () => {
    if (page > 1) {
      setPage(page - 1);
    }
  };

  const nextButton = async () => {
    if (totalPages > page) {
      setPage(page + 1);
    }
  };

  return (
    <>
      <Header />
      <Container className="mt--7" fluid>
        <Row>
          <div className="col">
            <Card className="shadow">
              <CardHeader className="border-0 d-flex justify-content-between">
                <h3>FAQ</h3>
                {permissions.includes("create-faq") && (
                  <Button color="info" onClick={createFaq}>
                    Create
                  </Button>
                )}
              </CardHeader>
              <Table
                className="align-items-center table-flush"
                responsive
                style={{ tableLayout: "fixed", width: "100%" }}
              >
                <thead className="thead-light">
                  <tr>
                    <th scope="col" className="faq-th-small">
                      #
                    </th>
                    <th scope="col" className="faq-th-question">
                      Question
                    </th>
                    <th scope="col" className="faq-th-answer">
                      Answer
                    </th>
                    {/* <th scope="col" className="faq-th-display_order">
                      Display Order
                    </th> */}
                    <th scope="col" className="faq-th-status">
                      Status
                    </th>
                    <th scope="col" className="faq-th-created-at">
                      Created At
                    </th>
                    {permissions.includes("update-faq" || "delete-faq") && (
                      <th scope="col" style={{ width: "80px" }} />
                    )}
                  </tr>
                </thead>
                <tbody>
                  {faqData.length > 0 ? (
                    faqData.map((faq, index) => (
                      <tr key={index}>
                        <th scope="faq-th-small">
                          {(page - 1) * perPage + index + 1}
                        </th>
                        <td className="faq-th-question">{faq.question}</td>
                        <td className="faq-th-answer ">{faq.answer}</td>
                        {/* <td className="faq-th-display_order">
                          {faq.display_order}
                        </td> */}
                        <td className="faq-th-status">
                          <FormControlLabel
                            control={
                              <Switch
                                checked={faq.status}
                                onChange={() =>
                                  handleStatusChange(faq.id, !faq.status)
                                }
                              />
                            }
                          />
                        </td>
                        <td className="faq-th-created-at">
                          {faq.created_at
                            ? moment(faq.created_at).format("DD MMMM, YYYY")
                            : "-"}
                        </td>
                        {permissions.includes("update-faq" || "delete-faq") && (
                          <td className="text-center">
                            <UncontrolledDropdown>
                              <DropdownToggle
                                className="btn-icon-only text-light"
                                href="#pablo"
                                role="button"
                                size="sm"
                                color=""
                                onClick={(e) => e.preventDefault()}
                              >
                                <i className="fas fa-ellipsis-v" />
                              </DropdownToggle>
                              <DropdownMenu
                                className="dropdown-menu-arrow"
                                right
                              >
                                {permissions.includes("update-faq") && (
                                  <DropdownItem
                                    onClick={() => handleEdit(faq.id)}
                                  >
                                    <i
                                      className="fas fa-edit"
                                      style={{
                                        color: "#1976d2",
                                        cursor: "pointer",
                                        marginRight: "10px",
                                      }}
                                    ></i>
                                    Edit
                                  </DropdownItem>
                                )}
                                {permissions.includes("delete-faq") && (
                                  <DropdownItem
                                    onClick={() => handleDelete(faq.id)}
                                  >
                                    <i
                                      className="fas fa-trash"
                                      style={{
                                        color: "red",
                                        cursor: "pointer",
                                        marginRight: "10px",
                                      }}
                                    ></i>
                                    Delete
                                  </DropdownItem>
                                )}
                              </DropdownMenu>
                            </UncontrolledDropdown>
                          </td>
                        )}
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td>No record found</td>
                    </tr>
                  )}
                </tbody>
              </Table>
              <CardFooter className="py-4">
                <Pagination
                  page={page}
                  perPage={perPage}
                  totalRecords={totalRecords}
                  totalPages={totalPages}
                  records={records}
                  prevButton={prevButton}
                  nextButton={nextButton}
                />
              </CardFooter>
            </Card>
          </div>
        </Row>
      </Container>
    </>
  );
};
export default Faq;
